module.exports = __webpack_public_path__ + "img/Flecha_abajo.727dc41b.svg";